import { render, staticRenderFns } from "./CreateRedirect.vue?vue&type=template&id=5f24c3aa&"
import script from "./CreateRedirect.vue?vue&type=script&lang=js&"
export * from "./CreateRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports